'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var emailConfig = require('./email-config.js');
var passwordConfig = require('./password-config.js');
var passwordIndicatorConfig = require('./password-indicator-config.js');
var progressBarConfig = require('./progress-bar-config.js');
var firstNameConfig = require('./first-name-config.js');
var lastNameConfig = require('./last-name-config.js');
var genderConfig = require('./gender-config.js');
var dateConfig = require('./date-config.js');
var addressConfig = require('./address-config.js');
var cityConfig = require('./city-config.js');
var countryConfig = require('./country-config.js');
var postCodeConfig = require('./post-code-config.js');
var currencyConfig = require('./currency-config.js');
var phoneConfig = require('./phone-config.js');
var consentConfig = require('./consent-config.js');
var twoFactorConfig = require('./two-factor-config.js');
var securityQuestionConfig = require('./security-question-config.js');
var ibanConfig = require('./iban-config.js');
var personalIdConfig = require('./personal-id-config.js');
var nationalityConfig = require('./nationality-config.js');
var addressAutocompleteConfig = require('./address-autocomplete-config.js');



exports.email = emailConfig.email;
exports.hasEmailSuggestion = emailConfig.hasEmailSuggestion;
exports.suggestedEmail = emailConfig.suggestedEmail;
exports.password = passwordConfig.password;
exports.passwordIndicator = passwordIndicatorConfig.passwordIndicator;
exports.progressBar = progressBarConfig.progressBar;
exports.progressBar1of3 = progressBarConfig.progressBar1of3;
exports.progressBar2of3 = progressBarConfig.progressBar2of3;
exports.firstName = firstNameConfig.firstName;
exports.lastName = lastNameConfig.lastName;
exports.gender = genderConfig.gender;
exports.birthDate = dateConfig.birthDate;
exports.address = addressConfig.address;
exports.city = cityConfig.city;
exports.country = countryConfig.country;
exports.postCode = postCodeConfig.postCode;
exports.currency = currencyConfig.currency;
exports.phone = phoneConfig.phone;
exports.consent = consentConfig.consent;
exports.twoFactor = twoFactorConfig.twoFactor;
exports.securityAnswer = securityQuestionConfig.securityAnswer;
exports.securityQuestion = securityQuestionConfig.securityQuestion;
exports.iban = ibanConfig.iban;
exports.personalID = personalIdConfig.personalID;
exports.nationality = nationalityConfig.nationality;
exports.addressAutocomplete = addressAutocompleteConfig.addressAutocomplete;
